import { Input, InputProps } from '@/components/ui/input';
import { Field, FieldProps } from 'formik';
import {
  InputGroup,
  InputGroupAddon,
  InputGroupInput,
  InputGroupText,
} from '../ui/input-group';

export type ConnectedInputProps = { name: string } & Omit<InputProps, 'form'>;

export const ConnectedInput: React.FC<ConnectedInputProps> = ({
  name,
  ...props
}) => (
  <Field name={name}>
    {({ field }: FieldProps) => <Input {...field} {...props} />}
  </Field>
);

export const ConnectedInputWithRightAddon: React.FC<
  {
    name: string;
    rightAddon?: React.ReactNode | undefined;
  } & React.InputHTMLAttributes<HTMLInputElement>
> = ({ name, rightAddon, className, ...props }) => (
  <Field name={name}>
    {({ field }: FieldProps) => (
      <InputGroup
        className={className}
        data-disabled={props.disabled || undefined}
      >
        <InputGroupInput {...field} value={field.value ?? ''} {...props} />
        {rightAddon && (
          <InputGroupAddon align="inline-end">
            <InputGroupText>{rightAddon}</InputGroupText>
          </InputGroupAddon>
        )}
      </InputGroup>
    )}
  </Field>
);
